import { useEffect } from 'react';

import { IProps } from './types';

// При дизейбле одного из свойств можно очистить значение, если это свойство было выбрано раньше
export const useCleanDisabledSelector = ({ source, value, onChange, defaultValue }: IProps) => {
  useEffect(() => {
    if (!source) {
      return;
    }

    // Проверяем, заблокировано ли текущее значение
    const currentValueIsDisabled = source.some(element => element.value === value && element.disabled);

    if (currentValueIsDisabled) {
      if (defaultValue !== undefined) {
        // Если есть defaultValue, используем его, иначе очищаем значение
        onChange(defaultValue);
      } else {
        onChange();
      }
    }
  }, [value, source, onChange, defaultValue]);
};
